import React from "react";

const Hdg = ({ section = "" }) => {
  return (
    <h1>
      Champions <i>fore</i> Charity {section ? section : ""}
    </h1>
  );
};

export default Hdg;
